import { NumberField, TextFieldComponent } from '../../external/ensolvers-core-frontend-mui/components/Common/FormComponents';
import GenericForm from '../../external/ensolvers-core-frontend-mui/components/Common/GenericForm';
import Property from '../../models/Property';
import { ColorUtils } from '../../utils/ColorUtils';
import { useStyles } from '../Main/formStyles';

interface Props {
  editProperty: Property | undefined;
  onClose: () => void;
  onSave: (instance: Property) => void;
}

export default function PropertyEditDialog(props: Props) {
  const customStyles = useStyles();
  
  if (!props.editProperty) {
    return null;
  }

  return (
    <GenericForm<Property>
      headerStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom:-10, marginTop:10 }}
      buttonStyles={{ marginRight: 20, color: 'white', backgroundColor: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, marginBottom: 10 }}
      cancelButtonStyles={{ color: ColorUtils.ENSOLVERS_ORANGE_REBRANDING, border: `1px solid ${ColorUtils.ENSOLVERS_ORANGE_REBRANDING}`, marginBottom: 10 }}
      dialogStyles={customStyles.root}      
      dialog={true}
      open={!!props.editProperty}
      instance={props.editProperty}
      title={`Edit Property ${props.editProperty.key}`}
      onSave={(instance) => {
        props.onSave(instance);
        props.onClose();
      }}
      onCancel={() => props.onClose()}
      dialogCustomSubmitMessage={'Save'}
      renderContent={(register, errors, control) => (
        <>
          <TextFieldComponent register={register} errors={errors} control={control} propertyName={'key'} label={'Key'} required={true} />
          <TextFieldComponent
            register={register}
            errors={errors}
            control={control}
            propertyName={'content'}
            label={'Content'}
            required={true}
          />
          <NumberField
            register={register}
            errors={errors}
            control={control}
            propertyName={'sinceVersion'}
            label={'Since version'}
            required={true}
          />
        </>
      )}
    />
  );
}
